import React from 'react';
import './HowItWorks.css';
import { FaComments, FaClipboardList, FaCogs, FaRocket } from 'react-icons/fa';

const HowItWorks = () => {
  const steps = [
    {
      icon: <FaComments />,
      step: 'Step 1',
      title: 'Consultation',
      description: 'We start by understanding your business goals, challenges, and specific requirements.'
    },
    {
      icon: <FaClipboardList />,
      step: 'Step 2',
      title: 'Strategy Development',
      description: 'Our team designs a customized plan tailored to your needs, leveraging the best tools and techniques.'
    },
    {
      icon: <FaCogs />,
      step: 'Step 3',
      title: 'Execution',
      description: 'We implement the strategy, sourcing leads or candidates with precision and efficiency.'
    },
    {
      icon: <FaRocket />,
      step: 'Step 4',
      title: 'Delivery & Support',
      description: 'Receive high-quality results and ongoing support to ensure your continued success.'
    }
  ];

  return (
    <section className="how-it-works section">
      <div className="container">
        <h2 className="section-title">How It Works</h2>
        <p className="section-subtitle">
          A seamless process designed to deliver results efficiently.
        </p>
        
        <div className="steps-container">
          {steps.map((item, index) => (
            <div className="step-card" key={index}>
              <div className="step-number">{index + 1}</div>
              <div className="step-icon">{item.icon}</div>
              <h3 className="step-title">{item.title}</h3>
              <p className="step-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;